import React, { useEffect, useState, useContext } from 'react';
import { queryAttachmentService } from '../../services/RenderImageService';
import { LoginContext } from '../../context/LoginContext';
import { FileText, Download } from 'lucide-react';

interface DocumentPreviewProps {
  docId: string;
  label?: string;
  className?: string;
}

const DocumentPreview: React.FC<DocumentPreviewProps> = ({ docId, label, className }) => {
  const { user } = useContext(LoginContext);
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const userId = user?.userId || "";

  useEffect(() => {
    if (docId && userId) {
      setIsLoading(true);
      queryAttachmentService.getAttachment(docId, userId)
        .then((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            setDownloadUrl(url);
          }
        })
        .catch(err => console.error("Error fetching document:", err))
        .finally(() => setIsLoading(false));
    }
  }, [docId, userId]);

  if (!docId) return null;

  return (
    <div className={`document-preview-container ${className || ''}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px', 
        padding: '8px 12px', 
        backgroundColor: '#f3f4f6', 
        borderRadius: '6px',
        border: '1px solid #e5e7eb'
      }}>
        <FileText size={18} color="#4b5563" />
        <span style={{ fontSize: '14px', color: '#374151', fontWeight: 500 }}>
          {label || 'Document Template'}
        </span>
        {isLoading ? (
          <span style={{ fontSize: '12px', color: '#6b7280' }}>Loading...</span>
        ) : downloadUrl ? (
          <a 
            href={downloadUrl} 
            download={`Template_${docId}.docx`}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              backgroundColor: '#3b82f6',
              color: 'white',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
            title="Download Template"
          >
            <Download size={14} />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default DocumentPreview;
